module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-wink-97c61a62.svg";